import axios from "axios";

// Use explicit API origin in env or fallback to same-origin
const baseURL = (
  import.meta.env.VITE_API_BASE_URL || (typeof window !== "undefined" ? window.location.origin : "")
).replace(/\/+$/, "");

const api = axios.create({
  baseURL, // e.g., http://localhost:3000
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
